import {firebase, admin} from '../config/fbconfig';
const db = firebase.firestore();
class Login {
    static addAccount(registerData){
        return new Promise(async (resolve, reject) => {
         const snapshot = await db.collection('chromaUsers').where("email", "==", registerData.email).get()
         const userExists = snapshot.docs.map(doc => doc.data());
         if(userExists.length > 0){
             reject("Email already registered")
         }
 
         firebase.auth().createUserWithEmailAndPassword(registerData.email, registerData.password)
         .then((user) => {
             let myData ={
                 firstName: registerData.firstName,
                 email:registerData.email,
                 lastName:registerData.lastName,
                 phone:registerData.phone|| ' ',
                 UID: user.user.uid,
                 role: registerData.role
             } 
             db.collection('chromaUsers').add(myData).then(ref => {
                 ref.set({
                     id: ref.id
                 }, {
                     merge: true
                 }).then(() => {
                     resolve(ref.id)
                 }, (err) => {
                     return reject(err);
                 })
             });
             
             } , (err) => {
               console.log("promise rejected");
               reject();
           });
 
         })
     }
    static async userlogin(data){
        return new Promise((resolve, reject) =>{
            firebase.auth().signInWithEmailAndPassword(data.email, data.password).then(ref =>{
                localStorage.setItem('uid',ref.user.uid)
                return db.collection('chromaUsers').where("UID", "==", ref.user.uid).get()
            }).then(ref =>{
                if(ref){
                   resolve(ref.docs.map(doc => doc.data()))
                }
            }).catch(e =>{
                reject(e)
            })
        })
    
   
    }
    static forgotPasswrod(){
        return new Promise((resolve, reject) => {
        });
    }
    static async getUserDetails(){
            let UserID =localStorage.getItem('uid');
            const snapshot = await db.collection('chromaUsers').where("UID", "==", UserID).get()
           return snapshot.docs.map(doc => doc.data());
    }
    static addAccount1(registerData){
       return new Promise((resolve, reject) => {
        admin.auth().createUser({
            email: registerData.email,
            emailVerified: false,
            phoneNumber: registerData.phone || '',
            password: registerData.password,
            photoURL: 'https://cdn4.iconfinder.com/data/icons/eldorado-user/40/user-512.png',
            displayName: registerData.firstName + ' ' + registerData.lastName,
            disabled: false
          }).then((response) => {
                  let myData ={
                      firstName: registerData.firstName,
                      email:registerData.email,
                      lastName:registerData.lastName,
                      phone:registerData.phone|| ' ',
                      UID: response.uid,
                      role: registerData.role
                  } 
                db.collection('chromaUsers').add(myData).then(ref => {
                    ref.set({
                        id: ref.id
                    }, {
                        merge: true
                    }).then(() => {
                        resolve(ref.id)
                    }, (err) => {
                        return reject(err);
                    })
                });
              }, (err) => {
                  console.log("promise rejected");
                  reject();
              });
       })
    }
    
}
export default Login